import FilledButton, {
  FilledButtonPropsBase,
} from "@/components/common/filled-button";

const TertiaryFilledButton = (props: FilledButtonPropsBase) => {
  return (
    <FilledButton
      {...props}
      backgroundColor={"#212121"}
      color={"#F9A825"}
      hoveringColor={"#F9A825"}
      padding={"8px 0"}
    />
  );
};

export default TertiaryFilledButton;
